"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ABI_LENDING_POOLS = void 0;
exports.ABI_LENDING_POOLS = [
    {
        inputs: [],
        stateMutability: 'nonpayable',
        type: 'constructor',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'spender',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'value',
                type: 'uint256',
            },
        ],
        name: 'Approval',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'sender',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'assets',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'shares',
                type: 'uint256',
            },
        ],
        name: 'Deposit',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'bool',
                name: 'bDepositsPaused',
                type: 'bool',
            },
            {
                indexed: false,
                internalType: 'bool',
                name: 'bWithdrawalsPaused',
                type: 'bool',
            },
        ],
        name: 'DepositWithdrawalStatusChanged',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'uint8',
                name: 'version',
                type: 'uint8',
            },
        ],
        name: 'Initialized',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'address',
                name: 'loanAddr',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'aprWithTwoDecimals',
                type: 'uint256',
            },
        ],
        name: 'NewLoanDeployedByPool',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'uint256',
                name: 'withdrawalAmount',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'tokenAddr',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'destinationAddr',
                type: 'address',
            },
        ],
        name: 'OnEmergencyWithdraw',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'uint256',
                name: 'prevValue',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'newValue',
                type: 'uint256',
            },
        ],
        name: 'OnMaxSupplyChanged',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'previousOwner',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'OwnershipTransferred',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'from',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'value',
                type: 'uint256',
            },
        ],
        name: 'Transfer',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: 'address',
                name: 'sender',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'receiver',
                type: 'address',
            },
            {
                indexed: true,
                internalType: 'address',
                name: 'owner',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'assets',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'shares',
                type: 'uint256',
            },
        ],
        name: 'Withdraw',
        type: 'event',
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: 'address',
                name: 'ownerAddr',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'address',
                name: 'receiverAddr',
                type: 'address',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'shares',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'assets',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'fee',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'year',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'month',
                type: 'uint256',
            },
            {
                indexed: false,
                internalType: 'uint256',
                name: 'day',
                type: 'uint256',
            },
        ],
        name: 'WithdrawalRequested',
        type: 'event',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'ownerAddr',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'spenderAddr',
                type: 'address',
            },
        ],
        name: 'allowance',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'spender',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'value',
                type: 'uint256',
            },
        ],
        name: 'approve',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'asset',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'addr',
                type: 'address',
            },
        ],
        name: 'balanceOf',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'loanAddr',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'callbackPeriodInHours',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'gracePeriodInHours',
                type: 'uint256',
            },
        ],
        name: 'callLoan',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'loanAddr',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'lateInterestFeeWithTwoDecimals',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'latePrincipalFeeWithTwoDecimals',
                type: 'uint256',
            },
        ],
        name: 'changeLateFees',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'loanAddr',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'maintenanceCollateralRatioWith2Decimals',
                type: 'uint256',
            },
        ],
        name: 'changeMaintenanceCollateralRatio',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'year',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'month',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'day',
                type: 'uint256',
            },
            {
                internalType: 'address',
                name: 'receiverAddr',
                type: 'address',
            },
        ],
        name: 'claim',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'collectFees',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'newLagDuration',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'newMaxDepositAmount',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'newMaxWithdrawalAmount',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'newMaxTokenSupply',
                type: 'uint256',
            },
            {
                internalType: 'address',
                name: 'newUnderlyingAsset',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'newLoansOperator',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'newLoansDeployerAddress',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'newFeesCollectorAddr',
                type: 'address',
            },
            {
                internalType: 'uint8',
                name: 'newProcessingHour',
                type: 'uint8',
            },
        ],
        name: 'configurePool',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'shares',
                type: 'uint256',
            },
        ],
        name: 'convertToAssets',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'assets',
                type: 'uint256',
            },
        ],
        name: 'convertToShares',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'decimals',
        outputs: [
            {
                internalType: 'uint8',
                name: '',
                type: 'uint8',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: 'uint256',
                        name: 'fundingPeriodInSeconds',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'newPaymentIntervalInSeconds',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'newLoanAmountInPrincipalTokens',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'originationFeePercent2Decimals',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'newAprWithTwoDecimals',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'initialCollateralRatioWith2Decimals',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'maintenanceCollateralRatioWith2Decimals',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'lateInterestFee',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'latePrincipalFee',
                        type: 'uint256',
                    },
                    {
                        internalType: 'uint256',
                        name: 'expiryInfo',
                        type: 'uint256',
                    },
                    {
                        internalType: 'string',
                        name: 'loanTypeInfo',
                        type: 'string',
                    },
                    {
                        internalType: 'address',
                        name: 'lenderAddr',
                        type: 'address',
                    },
                    {
                        internalType: 'address',
                        name: 'borrowerAddr',
                        type: 'address',
                    },
                    {
                        internalType: 'address',
                        name: 'newCollateralToken',
                        type: 'address',
                    },
                    {
                        internalType: 'address',
                        name: 'newPrincipalToken',
                        type: 'address',
                    },
                    {
                        internalType: 'address',
                        name: 'feesManagerAddr',
                        type: 'address',
                    },
                    {
                        internalType: 'address',
                        name: 'priceOracleAddress',
                        type: 'address',
                    },
                    {
                        internalType: 'address',
                        name: 'feesCollectorAddress',
                        type: 'address',
                    },
                    {
                        internalType: 'address',
                        name: 'categoryFeesAdress',
                        type: 'address',
                    },
                    {
                        internalType: 'bool',
                        name: 'allowSeizeCollateral',
                        type: 'bool',
                    },
                ],
                internalType: 'struct LoanDeploymentParams',
                name: 'loanParams',
                type: 'tuple',
            },
        ],
        name: 'deployLoan',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'assets',
                type: 'uint256',
            },
            {
                internalType: 'address',
                name: 'receiver',
                type: 'address',
            },
        ],
        name: 'deposit',
        outputs: [
            {
                internalType: 'uint256',
                name: 'shares',
                type: 'uint256',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'depositsPaused',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'contract IERC20',
                name: 'token',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'destinationAddr',
                type: 'address',
            },
        ],
        name: 'emergencyWithdraw',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'feesCollector',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'loanAddr',
                type: 'address',
            },
        ],
        name: 'fundLoan',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'year',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'month',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'day',
                type: 'uint256',
            },
            {
                internalType: 'address',
                name: 'receiverAddr',
                type: 'address',
            },
        ],
        name: 'getBurnableAmountByReceiver',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'year',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'month',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'day',
                type: 'uint256',
            },
            {
                internalType: 'address',
                name: 'receiverAddr',
                type: 'address',
            },
        ],
        name: 'getClaimableAmountByReceiver',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getInitializedVersion',
        outputs: [
            {
                internalType: 'uint8',
                name: '',
                type: 'uint8',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'year',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'month',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'day',
                type: 'uint256',
            },
        ],
        name: 'getRequirementByDate',
        outputs: [
            {
                internalType: 'uint256',
                name: 'shares',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'assets',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'year',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'month',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'day',
                type: 'uint256',
            },
        ],
        name: 'getScheduledTransactionsByDate',
        outputs: [
            {
                internalType: 'uint256',
                name: 'totalTransactions',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'executionEpoch',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getTotalLoansDeployed',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'getWithdrawalEpoch',
        outputs: [
            {
                internalType: 'uint256',
                name: 'year',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'month',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'day',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'claimableEpoch',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'globalLiabilityShares',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'globalLoansAmount',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
            {
                internalType: 'uint8',
                name: 'erc20Decimals',
                type: 'uint8',
            },
            {
                internalType: 'string',
                name: 'erc20Symbol',
                type: 'string',
            },
            {
                internalType: 'string',
                name: 'erc20Name',
                type: 'string',
            },
        ],
        name: 'initialize',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'lagDuration',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'loanAddr',
                type: 'address',
            },
        ],
        name: 'liquidate',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'liquidationHour',
        outputs: [
            {
                internalType: 'uint8',
                name: '',
                type: 'uint8',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        name: 'loansDeployed',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'loansDeployerAddress',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'loansOperator',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        name: 'maxDeposit',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'maxDepositAmount',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        name: 'maxMint',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'holderAddr',
                type: 'address',
            },
        ],
        name: 'maxRedeem',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'maxSupply',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'holderAddr',
                type: 'address',
            },
        ],
        name: 'maxWithdraw',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'maxWithdrawalAmount',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'shares',
                type: 'uint256',
            },
            {
                internalType: 'address',
                name: 'receiver',
                type: 'address',
            },
        ],
        name: 'mint',
        outputs: [
            {
                internalType: 'uint256',
                name: 'assets',
                type: 'uint256',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'name',
        outputs: [
            {
                internalType: 'string',
                name: '',
                type: 'string',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'notifyLoanClosed',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'notifyLoanMatured',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'effectiveLoanAmount',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'principalRepaid',
                type: 'uint256',
            },
        ],
        name: 'notifyPrincipalRepayment',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'owner',
        outputs: [
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'bool',
                name: 'bPauseDeposits',
                type: 'bool',
            },
            {
                internalType: 'bool',
                name: 'bPauseWithdrawals',
                type: 'bool',
            },
        ],
        name: 'pauseDepositsAndWithdrawals',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'assets',
                type: 'uint256',
            },
        ],
        name: 'previewDeposit',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'shares',
                type: 'uint256',
            },
        ],
        name: 'previewMint',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'shares',
                type: 'uint256',
            },
        ],
        name: 'previewRedeem',
        outputs: [
            {
                internalType: 'uint256',
                name: 'assets',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'assets',
                type: 'uint256',
            },
        ],
        name: 'previewWithdraw',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'year',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'month',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'day',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'maxLimit',
                type: 'uint256',
            },
        ],
        name: 'processAllClaimsByDate',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'loanAddr',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'newAprWithTwoDecimals',
                type: 'uint256',
            },
        ],
        name: 'proposeNewApr',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        name: 'redeem',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'pure',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'shares',
                type: 'uint256',
            },
            {
                internalType: 'address',
                name: 'receiverAddr',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'holderAddr',
                type: 'address',
            },
        ],
        name: 'requestRedeem',
        outputs: [
            {
                internalType: 'uint256',
                name: 'assets',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'claimableEpoch',
                type: 'uint256',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [],
        name: 'symbol',
        outputs: [
            {
                internalType: 'string',
                name: '',
                type: 'string',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'totalAssets',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'totalCollectableFees',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'totalSupply',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'value',
                type: 'uint256',
            },
        ],
        name: 'transfer',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'from',
                type: 'address',
            },
            {
                internalType: 'address',
                name: 'to',
                type: 'address',
            },
            {
                internalType: 'uint256',
                name: 'value',
                type: 'uint256',
            },
        ],
        name: 'transferFrom',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'address',
                name: 'newOwner',
                type: 'address',
            },
        ],
        name: 'transferOwnership',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'newMaxDepositAmount',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'newMaxWithdrawalAmount',
                type: 'uint256',
            },
            {
                internalType: 'uint256',
                name: 'newMaxTokenSupply',
                type: 'uint256',
            },
        ],
        name: 'updateIssuanceLimits',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'newDuration',
                type: 'uint256',
            },
        ],
        name: 'updateTimelockDuration',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: 'newWithdrawalFee',
                type: 'uint256',
            },
        ],
        name: 'updateWithdrawalFee',
        outputs: [],
        stateMutability: 'nonpayable',
        type: 'function',
    },
    {
        inputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
            {
                internalType: 'address',
                name: '',
                type: 'address',
            },
        ],
        name: 'withdraw',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'pure',
        type: 'function',
    },
    {
        inputs: [],
        name: 'withdrawalFee',
        outputs: [
            {
                internalType: 'uint256',
                name: '',
                type: 'uint256',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
    {
        inputs: [],
        name: 'withdrawalsPaused',
        outputs: [
            {
                internalType: 'bool',
                name: '',
                type: 'bool',
            },
        ],
        stateMutability: 'view',
        type: 'function',
    },
];
//# sourceMappingURL=LendingPool.js.map